import appConfig from '~/config/app'

let firebase: Promise<typeof import('./init')> | undefined

function getFirebase(): Promise<typeof import('./init')> {
  if (!firebase) {
    firebase = import('./init')
  }

  return firebase
}

function execute(functionPromise?: Promise<() => void>): Promise<void> | undefined {
  return functionPromise?.then((func) => func())
}

// add global  helper functions for E2E testing
if (!appConfig.isProdEnvironment && typeof window !== 'undefined') {
  const testUtils = window.testUtils ?? {}

  testUtils.signInWithFirebaseToken = async (token: string) => {
    const { signInWithCustomToken, auth } = await getFirebase()
    await signInWithCustomToken(auth, token)
  }

  window.testUtils = testUtils
}

export { execute, getFirebase }
